/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import e from"../../../core/Logger.js";function r(r,t,a){if(null==r)return null;const n=t.readArcadeFeature();t.contextTimeZone=a.$view?.timeZone;try{return r.evaluate({...a,$feature:n},r.services)}catch(u){return e.getLogger("esri.views.2d.support.arcadeOnDemand").warn("Feature arcade evaluation failed:",u),null}}export{r as default};
